<mat-expansion-panel togglePosition="before" displayMode="flat">
    <mat-expansion-panel-header>
      <mat-panel-title class="m-0">
        <span class="flex-fill"> Validation</span>
        <mat-chip>{{widget.widgetConfig?.validations?.length || 0}}</mat-chip>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="ps-4">
      <ng-container>
        <mat-list role="list">
          <mat-list-item class="item-selected" [class.active]="i === selectedValidationIndex && editMode" role="listitem" *ngFor="let validation of widget.widgetConfig.validations;let i = index">
            <ng-container *ngIf="widget && widget.widgetConfig && widget.widgetConfig.validations && widget.widgetConfig.validations.length > 0">
            <div class="d-flex gap-3 flex-nowrap align-items-center py-2">
              <div class="item-start flex-fill text-multi-line">
                <h6 class="title">{{ validation.validation_type }}:
                  {{ getValidationValue(validation.validation_type,validation.validation_value) }}</h6>
                <p>{{ validation?.error_message }}</p>
              </div>
              <div class="item-end control-buttons">
                @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <button mat-icon-button matSuffix (click)="editValidations(validation)">
                    <mat-icon>edit</mat-icon>
                </button>
                  <button mat-icon-button matSuffix (click)="deleteValidation(i)">
                  <mat-icon>delete</mat-icon>
                </button>
                }
            </div>
            </div>
          </ng-container>
        </mat-list-item>
      </mat-list>
      @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
        <div *ngIf="showValidationForm">
          <div class="mat-form-field-container">
            <form [formGroup]="validationForm">
              <mat-form-field class="w-100 mt-3" appearance="outline">
                <mat-label>Validation Type</mat-label>
                <mat-select  formControlName="selectedValidationType"
                  (selectionChange)="onSelectChange()" disableRipple>
                    <mat-option *ngFor="let option of inputFieldValidationData" [value]="option">
                      {{ option }}</mat-option>
                </mat-select>
              </mat-form-field>
              <span class="error-message" *ngIf="isSelectedValidationType">Please select Validation Type</span>
              <mat-form-field *ngIf="checkValidationMatched(validationNames.required)" class="w-100" appearance="outline">
                <mat-label>Error Message</mat-label>
                <input matInput type="text" formControlName="requiredMessage" placeholder="Enter error message" (input)="onLengthAdd($event)"/>
              </mat-form-field>

              <mat-form-field *ngIf="checkValidationMatched(validationNames.minimum_length) || checkValidationMatched(validationNames.maximum_length)"
                class="w-100 mb-2" appearance="outline">
                <mat-label>{{ checkValidationMatched(validationNames.minimum_length) ? 'Minimum Length' : 'Maximum Length'}}</mat-label>
                <input matInput type="number" formControlName="validationValue" (input)="onLengthAdd($event)"
                [placeholder]="this.validationForm.get('selectedValidationType')?.value+'*'"  libPositiveIntegerInput min="1" />
                <mat-hint class="text-danger" *ngIf="isLengthValidation && checkValidationMatched(validationNames.maximum_length)">Maximum length should be greater than Minimum length</mat-hint>
                <mat-hint class="text-danger" *ngIf="isLengthValidation && checkValidationMatched(validationNames.minimum_length)">Minimum length should be lesser than Maximum length</mat-hint>
              </mat-form-field>

              <mat-form-field  *ngIf="checkValidationMatched(validationNames.minimum_length) || checkValidationMatched(validationNames.maximum_length)" class="w-100 " [class.mt-2]="isLengthValidation" appearance="outline">
                <mat-label>Error Message</mat-label>
                <input matInput type="text" formControlName="requiredMessage" placeholder="Enter error message" />
              </mat-form-field>

              <mat-form-field *ngIf="checkValidationMatched(validationNames.start_date)  || checkValidationMatched(validationNames.end_date)" class="w-100"
                appearance="outline">
                <input matInput [matDatepicker]="picker" [placeholder]="this.validationForm.get('selectedValidationType')?.value" formControlName="validationValue"
                  (dateChange)="onDateChange($event)" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-hint class="text-danger" *ngIf="isDateValidation && checkValidationMatched(validationNames.start_date)">Start Date should be lesser than End Date</mat-hint>
                <mat-hint class="text-danger" *ngIf="isDateValidation && checkValidationMatched(validationNames.end_date)">End Date should be greater than Start Date</mat-hint>
              </mat-form-field>

              <ng-container *ngIf="checkValidationMatched(validationNames.regex)">
                <mat-form-field  class="w-100" appearance="outline">
                  <mat-label>Regular Expression</mat-label>
                  <input matInput type="text" required formControlName="regexPattern" placeholder="Enter regular expression"
                    (input)="validateRegex($event)" />
                  <mat-hint class="text-danger" *ngIf="isRegexValidation">Invalid Regular Expression</mat-hint>
                </mat-form-field>
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Error Message</mat-label>
                  <input matInput type="text" formControlName="requiredMessage" placeholder="Enter error message"  (input)="onLengthAdd($event)"/>
                </mat-form-field>
                <div class="m-1">
                  <a class="text-decoration-none btn btn-link" href="https://regexr.com/2rhq7" target="_blank">Regex Expressions Reference</a>
                </div>
              </ng-container>

              <span class="error-message" *ngIf="isValidationExist">Validation already exists!</span>
              <span class="error-message" *ngIf="isMessageValidation">Enter value to add Validation</span>
          </form>
          </div>
          @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
          <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addValidation()" 
          [disabled]="isLengthValidation || isMessageValidation || isValid || isDateValidation || isRegexValidation || !validationForm.dirty || isSelectedValidationType">
          <mat-icon>add</mat-icon> {{editMode ? 'Update' : 'Add'}} Validation
        </button>
      }
          
        </div>
      }
      </ng-container>

    </div>
  </mat-expansion-panel>